import { useTranslation } from 'react-i18next';

import {
  WordSelectionMode,
  WordSelectionModeDetails,
} from '../../../../constants/MemoryGames/wordSelectionMode';
import { SVGIconType } from '../../../../constants/svgIcon';
import {
  AppBar,
  BubbleStepsProgressBar,
  SvgIcon,
  TextJoyGroup,
} from '../../../Molecules';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import {
  TextOrderingUnit,
  TextOrderingUnitType,
} from '../../../../models/GameStore';

import styles from './CreateMemoryGameSelectWordsTemplate.module.css';

type selectWordCellProps = {
  mode: WordSelectionMode;
  units: TextOrderingUnit[];
};

type CreateMemoryGameSelectWordsTemplateProps = {
  type: QuickCreateGameMode | undefined;
  selectWordCells: selectWordCellProps[];
  showRequiredWarning: boolean;
  onClickMode: (cellIndex: number) => void;
  onUnitClick: (cellIndex: number, unitIndex: number) => void;
  onClickBack: () => void;
  onClickNext: () => void;
};

export const CreateMemoryGameSelectWordsTemplate = (
  props: CreateMemoryGameSelectWordsTemplateProps,
) => {
  const {
    type,
    selectWordCells,
    showRequiredWarning,
    onClickMode,
    onUnitClick,
    onClickBack,
    onClickNext,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.createMemorySelectWords}>
      <AppBar
        title={type ? t(getQuickCreateGameModeProps(type).name) : ''}
        onClickBack={onClickBack}
      />
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          {/* <p className={styles.gameTypeName}>
            {t(getQuickCreateGameModeProps(type).name)}
          </p> */}
          <p className={styles.gameTypeName}>{t('AI Memory Games')}</p>
        </div>
        <div className={styles.progress}>
          <BubbleStepsProgressBar currentStep={2} totalSteps={3} />
        </div>

        <p className={styles.title}>{t('Select Words')}</p>

        {selectWordCells.map((wordCell, index) => {
          const allWordsHint = wordCell.units.every(
            (unit) => unit.type === TextOrderingUnitType.Hint,
          );
          return (
            <div
              key={index}
              className={styles.gameCard}
              style={{
                border:
                  showRequiredWarning && allWordsHint
                    ? '1px solid #D95141'
                    : undefined,
              }}
            >
              <div className={styles.gameFooter}>
                <div className={styles.gameNumber}>{index + 1}</div>
              </div>
              <div className={styles.gameHeader}>
                <WordSelectionModeRow
                  mode={wordCell.mode}
                  onClick={() => {
                    onClickMode(index);
                  }}
                />
                <div
                  className={styles.wordSelectGuide}
                  style={{
                    color:
                      showRequiredWarning && allWordsHint
                        ? '#D95141'
                        : '#F08F00',
                  }}
                >
                  <p>{t('Click the word to select or deselect')}</p>
                </div>

                <div className={styles.cardContent}>
                  <TextJoyGroup
                    onUnitClick={(unitIndex) => {
                      onUnitClick(index, unitIndex);
                    }}
                    highlightColor="#A8B8D8"
                    units={wordCell.units}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.bottomBar}>
        <div className={styles.nextContainer}>
          <button className={styles.nextButton} onClick={onClickBack}>
            <SvgIcon
              className={styles.leftArrowIcon}
              name={SVGIconType.Arrow}
            />
            <span className={styles.nextText}>{t('Back')}</span>
          </button>
          <button className={styles.nextButton} onClick={onClickNext}>
            <span className={styles.nextText}>{t('Next')}</span>
            <SvgIcon
              className={styles.rightArrowIcon}
              name={SVGIconType.Arrow}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

interface WordSelectionModeProps {
  mode: WordSelectionMode;
  onClick: () => void;
}

const WordSelectionModeRow: React.FC<WordSelectionModeProps> = ({
  mode,
  onClick,
}: WordSelectionModeProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wordSelectionMode} onClick={onClick}>
      <SvgIcon
        name={WordSelectionModeDetails[mode].icon}
        width={24}
        height={24}
        stroke="black"
        fill="black"
      />
      <p className={styles.wordSelectionModeText}>
        {t(WordSelectionModeDetails[mode].displayName)}
      </p>
      <SvgIcon
        name={SVGIconType.Triangle}
        width={20}
        height={20}
        stroke={'#808080'}
        fill={'#808080'}
      />
    </div>
  );
};
